export default __webpack_public_path__ + "static/media/slide6.46d5805f.jpg";